import DevelopersBanner from "./developers.png";
import LoginBanner from "./login.png";
import ProfileBanner from "./profile.png";

export { LoginBanner, DevelopersBanner, ProfileBanner };
